<template>
  <div>
    <div class="login_top">
      <div class="logo">
        <img src="../../assets/images/3x/logo.png" alt="" style="width: 100%;border-radius: 100%">
      </div>
    </div>
    <div class="login_title">{{$t('message.code_login')}}</div>
    <div id="login">
      <div class="ipt_area">
        <div class="img_p">
          <img src="../../assets/images/3x/phone.png" alt=""><span style="padding-left: 0.2rem">{{qh_code}}</span>
        </div>
        <van-field label="" v-model="tel"/>
      </div>
      <div class="ipt_area ipt_area2">
        <div class="img_p">
          <img src="../../assets/images/3x/code.png" alt="">
        </div>
        <van-field label="" value="" v-model="code"/>
        <div class="code_btn" @click.prevent="sendCode" :disabled="unavailable" ref="sendCodeBtn">{{buttonText}}</div>
      </div>
      <div class="nav">
        <div @click="goPasd">{{$t('message.psd_login')}}</div>
        <div @click="goindex">{{$t('message.reback')}}{{$t('message.home')}}</div>
      </div>
      <van-button type="default" block @click="login">{{$t('message.determine')}}</van-button>
    </div>
  </div>
</template>

<script>

  import {login, sendCode, postRenInfo} from '../../ports/port'

  export default {
    name: "forget",
    data() {
      return {
        tel: '',//账号
        code: '',//密码
        unavailable: false,
        buttonText: this.$t('message.send_code'),
        show_error_tel: false,
        error_tel: '',
        show_error_psd: false,
        error_psd: '',
        sj_has_ipt: false,
        qh_code: this.$qh
      }
    },

    created() {
    },
    methods: {
      sendCode() {
        this.leave_tel();
        //定时器
        if (!this.unavailable && this.sj_has_ipt) {
          this.unavailable = true;
          let i = 61;
          let timer = setInterval(() => {
            i--;
            this.buttonText = i + 'S';
            if (i < 1) {
              clearInterval(timer);
              this.buttonText = this.$t('message.send_code');
              this.unavailable = false;
              this.$refs.sendCodeBtn.style.backgroundColor = '#014CCC';
            }
          }, 1000);
          this.$refs.sendCodeBtn.style.backgroundColor = '#a0bbe8';
          //发送验证码
          let data = {phone: this.tel, type: 2, ctype: 1};
          sendCode(data)
            .then(res => {
              if (res.data.code == 200) {
                this.$notify({type: 'success', message: this.$t('message.ver_code_success')});
              } else if (res.data.code == 202) {
                this.$notify({type: 'danger', message: this.$t('message.ver_code_error')});
              }
            })
            .catch(err => {
              this.$store.commit('edit', false);//关闭全局的loading
              if (err.toString().indexOf('timeout') != -1) {
                this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
              }
            })
        }
      },
      leave_pas() {
        this.code = this.code.replace(/\s+/g, "");
        if (this.code == "" || this.code == null || this.code == undefined) {
          this.error_psd = this.$t('message.th_yys_qsryzm');//请输入验证码
          this.show_error_psd = true;
        } else {
          this.show_error_psd = false;
        }
      },
      /***验证手机号***
       *
       * 越南手机，泰国手机号长度一样
       * 电话前面有0就10位，没有就9位
       */
      leave_tel() {
        this.tel = this.tel.replace(/\s+/g, "");
        if (this.tel == "" || this.tel == null || this.tel == undefined) {
          this.$toast({
            message: this.$t('message.enterPhone')
          });
        } else {

          if (!(/^\d{8}$|^\d{9}$/.test(this.tel.substring(1)))) {//去除84前的‘+’，然后算9位电话是否有0，有就10位，没有就9，然后在加84
            this.$toast({
              message: this.$t('message.verity_iphone')
            });
          } else {
            this.sj_has_ipt = true;
          }
        }
      },
      goPasd() {
        this.$router.push('/auth/loginCode')
      },
      goindex() {
        this.$router.push('/')
      },
      login() {
        this.$store.commit('edit', true);//打开全局的loading
        this.leave_tel();
        this.leave_pas();
        //平台、设备和操作系统
        var system = {
          win: false,
          mac: false,
          xll: false
        };
        //检测平台
        var p = navigator.platform;
        system.win = p.indexOf("Win") == 0;
        system.mac = p.indexOf("Mac") == 0;
        system.x11 = (p == "X11") || (p.indexOf("Linux") == 0);
        if (system.win || system.mac || system.xll) {
          this.$notify({
            type: 'danger',
            message: this.$t('message.use_phone')//请使用手机登录
          });
        } else {
          // let ids = this.$route.query.chntoken; //获取网址后面的chntoken
          let ids = sessionStorage.getItem('chntoken');
          if (ids == 'undefined' || ids == 'null') {
            ids = '';
          }
          let data = {
            phone: this.tel,
            code: this.code,
            d_id: '',
            login_type: '6',
            appName: this.$AppName,
            lang: 'vt-se',
            chntoken: ids
          };
          if (this.tel == "") {
            this.$notify({type: 'danger', message: this.$t('message.enterPhone')});
            this.$store.commit('edit', false);
          } else if (this.code == "") {
            this.$notify({type: 'danger', message: this.$t('message.message_ipt_code')});
            this.$store.commit('edit', false);
          } else if (this.tel != "" && this.code != "") {
            login(data)
              .then(res => {
                if (res.data.code == 200) {
                  let tk = JSON.stringify(res.data.data);
                  localStorage.setItem("tokenAll", tk);//本地保存token
                  this.$notify({
                    type: 'success', message: this.$t('message.login_success'), onClose: () => {
                      this.$router.push('/home');
                      this.$store.commit('edit', false);
                      sessionStorage.removeItem('chntoken');
                    }
                  });
                } else {
                  this.$notify({type: 'danger', message: this.$t('message.login_error')});
                  this.$store.commit('edit', false);
                }
              })
              .catch(err => {
                this.$store.commit('edit', false);//关闭全局的loading
                if (err.toString().indexOf('timeout') != -1) {
                  this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
                }
              })
          }
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .login_top {
    background-image: url("../../assets/images/1x/login_top.png");

    [data-dpr="3"] & {
      background-image: url("../../assets/images/3x/login_top.png");
    }

    [data-dpr="2"] & {
      background-image: url("../../assets/images/2x/login_top.png");
    }

    background-size: cover;
    height: 6.68rem;
    width: 100%;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;

    .logo {
      width: 2.04rem;
      height: 2.04rem;
      background: #fff;
      border-radius: 2.04rem;
      overflow: hidden;
      box-shadow: 0px 0px 10px #edf1f7;
    }
  }

  /deep/ .van-tabs__line {
    width: 50% !important;
    height: 2px !important;
    background-color: $color;
  }

  /deep/ .van-tab {
    border-bottom: 1px solid #152B64 !important;
  }

  #login {
    padding: 0.2rem 1.02rem;

    .ipt_area {
      position: relative;

      .img_p {
        position: absolute;
        z-index: 1;
        left: 0.45rem;
        top: 0;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        > img {
          height: 20px;
        }
      }
    }

    .ipt_area2 {
      position: relative;

      > img {
        left: 0.41rem;
      }

      .code_btn {
        background: $color;
        width: 3.31rem;
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
        border-bottom-right-radius: 8px;
        border-top-right-radius: 8px;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .ipt_text {
      margin-top: 0.21rem;
      font-size: 0.08rem;
      text-align: left;
      margin-bottom: 0.61rem;

      span {
        color: $color;
      }
    }
  }

  /deep/ .van-cell.van-field {
    @include borderSty;
    margin: 0.4rem 0;
  }

  /deep/ .van-cell {
    line-height: 20px !important;
  }

  .van-button--default {
    @include defaultBtn;
  }

  /deep/ .van-field__control {
    padding-left: 1.29rem !important;
  }

  /deep/ .ipt_area2 .van-field__control {
    padding-left: 0.65rem !important;
  }

  .login_title {
    color: $color;
    font-size: 16px;
    text-align: center;
    border-bottom: 1px solid #6278b3;
    padding: 15px 20px;
  }

  .nav {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    color: $color;
    margin-top: -1px;
    margin-bottom: 0.61rem;
  }
</style>



// WEBPACK FOOTER //
// src/pages/auth/login.vue